import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { CommonServices } from 'src/app/Common/CommonServices';
import { HostPortalClient, OutOfOffice, User } from 'src/app/Services/WOWApi.Service';
import { CustomServiceService } from 'src/app/Services/custom-service.service';

@Component({
  selector: 'app-out-of-office',
  templateUrl: './out-of-office.component.html',
  styleUrls: ['./out-of-office.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class OutOfOfficeComponent implements OnInit {
  loggedUser: User;
  outOfOffices: OutOfOffice[] = [];
  existingOutOfOffices: OutOfOffice[] = [];
  daysSelected: any[] = [];
  currentDate: OutOfOffice;
  minDate: Date;
  @ViewChild(MatCalendar) calendar: MatCalendar<Date>;
  constructor(
    private hostPortalClient: HostPortalClient,
    private customServices: CustomServiceService,
    private commonServices: CommonServices
  ) {
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 1);

  }

  ngOnInit(): void {
    this.loggedUser = this.customServices.GetLoggedInUser();
    this.hostPortalClient.getOutOfOffice(this.loggedUser.id, false).subscribe(data => {
      this.existingOutOfOffices = data;
      this.existingOutOfOffices.forEach(x => {
        const date =
          x.date.getFullYear() +
          "-" +
          ("00" + (x.date.getMonth() + 1)).slice(-2) +
          "-" +
          ("00" + x.date.getDate()).slice(-2);
        this.daysSelected.push(date);
        this.calendar.updateTodaysDate();
      });
      console.log(this.daysSelected);
    });
  }

  event: any;
  isSelected = (event: any) => {
    const date =
      event.getFullYear() +
      "-" +
      ("00" + (event.getMonth() + 1)).slice(-2) +
      "-" +
      ("00" + event.getDate()).slice(-2);
    return this.daysSelected.find(x => x == date) ? "selected" : null;
  };

  select(event: any, calendar: any) {
    const date =
      event.getFullYear() +
      "-" +
      ("00" + (event.getMonth() + 1)).slice(-2) +
      "-" +
      ("00" + event.getDate()).slice(-2);
    const index = this.daysSelected.findIndex(x => x == date);
    if (index < 0) this.daysSelected.push(date);
    else this.daysSelected.splice(index, 1);

    calendar.updateTodaysDate();
  }

  Save() {
    this.outOfOffices = [];
    this.currentDate = null;
    console.log(this.daysSelected);
    this.daysSelected.forEach(x => {
      const date = new Date(x);
      this.currentDate = new OutOfOffice();
      this.currentDate.id = 0;
      this.currentDate.active = true;
      this.currentDate.userId = this.loggedUser.id;
      this.currentDate.date = date;
      if (!this.outOfOffices.some(x => x.date === date)) {
        this.outOfOffices.push(this.currentDate);
      }

    });
    this.hostPortalClient.saveOutOfOffice(this.outOfOffices).subscribe(x => {
      this.commonServices.showMessage('X', "Out of Office dates saved successfully.");
    }, error => {
      this.commonServices.showMessage('Error', "An error occurred while saving Out of Office dates.");
    });
  }

}
